module.exports = __webpack_public_path__ + "img/esg-1-icon-4.b80fc160.svg";